<template lang="pug">
  include ./../../mixins
  +b.table-invoice
    +e.TABLE
      +e.thead.THEAD
        +e.TR
          +e.th--id.TH
            +e.info-wrapper--pointer(
              @click.prevent="changeSort('manufacturer')"
            )
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) MANUFACTURER
              +e.icon.icon--type_order
          +e.th.TH
            +e.info-wrapper
              +e.info-wrapper--pointer(
                @click.prevent="changeSort('model')"
              )
                +b.TEXT-BEMTO(
                  :fw="'bold'"
                  :lh="'small'"
                  :fs="'xs'"
                  :color="'black'"
                  :tag="'p'"
                ) MODEL
                +e.icon.icon--type_order
          +e.th.TH
            +e.info-wrapper--pointer(
              @click.prevent="changeSort('year')"
            )
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) YEAR
              +e.icon.icon--type_order
          +e.th.TH
            +e.info-wrapper--pointer
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) YEAR PERIOD
          +e.th.TH
            +e.info-wrapper--pointer
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) SERVICE
          +e.th.TH
            +e.info-wrapper--pointer
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) PRICE
          +e.th.TH
            +e.info-wrapper
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) REFUSED REQUESTS
          +e.th.TH
            +e.info-wrapper
              +b.TEXT-BEMTO(
                :fw="'bold'"
                :lh="'small'"
                :fs="'xs'"
                :color="'black'"
                :tag="'p'"
              ) PAID REQUESTS
      +e.TBODY
        +e.TR(
          v-for="(item, index) in objectList"
          :key="`${item.id}/${index}`"
        )
          +e.td.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.manufacturer || '-' }}
          +e.td.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.carModel || '-' }}
          +e.td.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.carYear || '-' }}
          +e.td.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.yearPeriod || '-' }}
          +e.td.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.serviceTitle || '-' }}
          +e.td.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.currentPrice || '-' }}
          +e.td.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.countNeg }}
          +e.td.TD
            +b.TEXT-BEMTO(
              :fw="'medium'"
              :lh="'small'"
              :fs="'xs'"
              :color="'black'"
              :tag="'p'"
            ) {{ item.countPos }}
</template>

<script>
export default {
  name: 'OrderStatisticsTable',
  props: [
    'objectList',
  ],
  data() {
    return {
      ordering: '-',
    }
  },
  methods: {
    setOrderHandler(key) {
      if (this.ordering.includes('-')) {
        this.ordering = key
      } else {
        this.ordering = `-${key}`
      }
    },
    async changeSort(key) {
      await this.setOrderHandler(key)
      this.$emit('ordering', this.ordering)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Tables/OrderStatisticsTable.vue